<app-sidebar></app-sidebar>
<app-header></app-header>

<div class="content-wrapper">

    <div class="card print-report-container">
        <!-- ส่วนค้นหา (ไม่แสดงตอนพิมพ์) -->
        <div class="no-print sticky search-section">
            <div class="card search-card">
                <div class="card-body">
                    <div class="row g-3 align-items-end flex-wrap">
                        <!--
                        <div class="col-2">
                            <mat-form-field class="example-full-width" appearance="fill">
                                <mat-label>--เลขกลุ่มตัด--</mat-label>
                                <input type="text" matInput placeholder="ระบุเลขกลุ่มตัด" maxlength="8" id="groupCode"
                                    [(ngModel)]="groupCode">
                            </mat-form-field>
                            <mat-progress-bar *ngIf="loading[0]" mode="indeterminate"></mat-progress-bar>
                        </div>
                        <div class="col-1">
                            <button mat-raised-button color="primary" [disabled]="!groupCode"
                                (click)="Loaddata2()">ค้นหา</button>
                        </div>
                        -->
                        <!--
                        <div class="col-3" *ngIf="dataApi1.length > 0">
                            <mat-form-field appearance="fill" class="farmer-select">
                                <mat-label>เลือกชาวไร่</mat-label>
                                <mat-select disableRipple required multiple [(ngModel)]="selectS"
                                    (selectionChange)="filter_data2()">
                                    <mat-option *ngFor="let item of dataApi1" [value]="item">
                                        {{ item.fmname }} | แปลงตัดเสร็จ-{{ item.cntF }}/{{ item.cnt }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        -->
                        <div class="col-4">
                            <div class="position-relative" style="min-width: 320px;">
                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="input-fm">เลือกชาวไร่</span>
                                    <input type="text" [(ngModel)]="params_like1.search" (input)="LoadDataLike1()"
                                        class="form-control" placeholder="Search..." />
                                    <button *ngIf="params_like1.search.length>0" class="btn btn-outline-secondary"
                                        (mousedown)="params_like1.search=''">✕</button>
                                </div>
                                <div *ngIf="data_list.length>0 && params_like1.search.length>0 && !isChecked"
                                    class="list-group position-absolute w-100"
                                    style="z-index: 1000; top: 100%; max-height: 320px; overflow-y: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.2);">
                                    <button type="button" *ngFor="let item of data_list; let i = index"
                                        (click)="push_dataone(item,1)" class="list-group-item list-group-item-action">
                                        [{{ item.fmcode }}]:{{ item.fmname }}, โซน:{{ item.SUPZONE}}
                                        | ตัดเสร็จ-{{ item.cntF }}/{{ item.cnt }}
                                    </button>
                                </div>
                            </div>
                            <mat-progress-bar *ngIf="loading[0]" mode="indeterminate"></mat-progress-bar>
                        </div>
                        <div class="col-auto" *ngIf="data_list.length > 0">
                            <mat-slide-toggle [(ngModel)]="isChecked">ซ่อนตัวเลือก:{{isChecked}}</mat-slide-toggle>
                        </div>
                        <!-- ปุ่มพิมพ์รายงาน -->
                        <div class="col-1" *ngIf="selectS.length > 0">
                            <div class="d-flex gap-2 align-items-center">
                                <button mat-raised-button color="accent" [disabled]="edit_st != 0"
                                    (click)="printPage()">
                                    <mat-icon>print</mat-icon> พิมพ์
                                </button>
                            </div>
                        </div>
                        <!-- ปุ่มเลื่อนไปยังชาวไร่ -->
                        <div class="col-5" *ngIf="selectS.length > 0">
                            <!--
                            <div class="d-flex flex-wrap gap-2 justify-content-center">
                                <button type="button" class="btn btn-outline-danger btn-sm" *ngFor="let fm of selectS"
                                    (click)="scrollTo(fm.fmname)">
                                    {{ fm.fmname }}
                                </button>
                            </div>
                            -->
                            <div class="btn-group" role="group" aria-label="Basic outlined example"
                                *ngFor="let fm of selectS">
                                <button type="button" class="btn btn-outline-primary" (click)="scrollTo(fm.fmname)">
                                    {{ fm.fmname }},<u style="color: black;">{{ fm.cntF }}/{{ fm.cnt }}</u></button>
                                <button type="button" class="btn btn-outline-danger" (click)="push_dataone(fm,0)">
                                    <i class="fa fa-close"></i></button>
                            </div>
                        </div>
                        <mat-progress-bar *ngIf="loading[2]" mode="indeterminate"></mat-progress-bar>
                    </div>
                </div>
            </div>
        </div>

        <!-- ส่วนรายงาน -->
        <div class="row justify-content-center report-content">
            <div class="col-12">
                <div class="report-card card" *ngFor="let dt of selectS" style="page-break-inside: avoid;">
                    <div class="report-logo">
                        <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO">
                    </div>
                    <div class="card-body report-body" [id]="dt.fmname">
                        <div class="report-info-section">
                            <h2 class="report-title">รายงานผลผลิต {{ yearN.yearDesc }}</h2>
                            <div class="report-info-grid">
                                <div class="info-row">
                                    <span class="info-label">ชื่อ</span>
                                    <span class="info-value border border-primary">{{ dt.fmname }}</span>,
                                    <span class="info-label">เลขบัญชี</span>
                                    <span class="info-value border border-primary">{{ dt.fmcode }}</span>
                                </div>
                                <!--
                                <div class="info-row">
                                    <span class="info-label">เกรดอ้อยปลูกใหม่ </span>
                                    <span class="info-value border border-primary"> {{ dt.gradeFM11 }} </span>,

                                    <span class="info-label">เกรดอ้อยตอ </span>
                                    <span class="info-value border border-primary"> {{ dt.gradeFM12 }} </span>,

                                    <span class="info-label">เกรดรวม </span>
                                    <span class="info-value border border-success"> {{ dt.gradeFM10 }} </span>
                                </div>
                                -->
                            </div>
                        </div>

                        <!-- ตารางประเมิน -->
                        <!--
                        <div class="report-table-wrapper">
                            <table class="table table-bordered assess-table">
                                <thead>
                                    <tr class="table-info text-center">
                                        <th></th>
                                        <th>พื้นที่(ไร่)</th>
                                        <th>ผลผลิต(ตัน/ไร่)</th>
                                        <th>ประเมิน(ตัน)</th>
                                    </tr>
                                </thead>
                                <tbody class="table-group-divider text-center">
                                    <tr>
                                        <td>ER</td>
                                        <td>{{ dt.landvalue_er | number:'1.2-2' }}</td>
                                        <td>{{ dt.yield_er | number:'1.2-2' }}</td>
                                        <td>{{ dt.Assess_er | number:'1.2-2' }}</td>
                                    </tr>
                                    <tr>
                                        <td>ERO</td>
                                        <td>{{ dt.landvalue_ero | number:'1.2-2' }}</td>
                                        <td>{{ dt.yield_ero | number:'1.2-2' }}</td>
                                        <td>{{ dt.Assess_ero | number:'1.2-2' }}</td>
                                    </tr>
                                    <tr>
                                        <td>ST</td>
                                        <td>{{ dt.landvalue_st | number:'1.2-2' }}</td>
                                        <td>{{ dt.yield_st | number:'1.2-2' }}</td>
                                        <td>{{ dt.Assess_st | number:'1.2-2' }}</td>
                                    </tr>
                                    <tr>
                                        <td>SR</td>
                                        <td>{{ dt.landvalue_sr | number:'1.2-2' }}</td>
                                        <td>{{ dt.yield_sr | number:'1.2-2' }}</td>
                                        <td>{{ dt.Assess_sr | number:'1.2-2' }}</td>
                                    </tr>
                                    <tr class="table-secondary">
                                        <td>รวม</td>
                                        <td>{{ dt.landvalue | number:'1.2-2' }}</td>
                                        <td>{{ dt.Ton | number:'1.2-2' }}</td>
                                        <td>{{ dt.Assess | number:'1.2-2' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>-->

                        <!-- ตารางรายงานผลผลิตแปลงตัดเสร็จ -->
                        <div class="card">
                            <div class="card-header">
                                <div class="row g-0">
                                    <div class="col-sm-6">
                                        <h5 class="mb-0"><b><u>ผลงานผลผลิต {{yearN.yearDesc}}</u></b></h5>
                                    </div>
                                    <div class="col-sm-6">
                                        <span class="info-label">ปริมาณตันเป้าหมาย</span>
                                        <span class="info-value border border-primary"> {{ dt.Assess | number }} </span>
                                        ตัน
                                        <span class="info-label">ผลผลิตเป้าหมาย</span>
                                        <span class="info-value border border-primary"> {{ dt.Ton | number }} </span>
                                        ตัน/ไร่
                                    </div>
                                </div>

                            </div>
                            <div class="card-body p-0">
                                <div class="report-table-wrapper">
                                    <table class="table table-bordered table-striped assess-table table-new-row-border">
                                        <thead class="table-new-row-border">
                                            <tr class="text-center">
                                                <th [attr.rowspan]="2">ประเภทอ้อย</th>
                                                <th [attr.colspan]="4">แปลงทั้งหมด</th>
                                                <th [attr.colspan]="4">แปลงตัดเสร็จ</th>
                                                <th colspan="2"><u style="text-align: right;">
                                                        ณ วันที่ {{ todaydate }}</u></th>
                                            </tr>
                                            <tr class="table-info text-center">
                                                <th>จำนวนแปลง</th>
                                                <th>พื้นที่(ไร่)</th>
                                                <th>เป้าหมาย(ตัน/ไร่)</th>
                                                <th>เป้าหมายตัน</th>

                                                <th>จำนวนแปลง</th>
                                                <th>พื้นที่(ไร่)</th>
                                                <th>ผลผลิต(ตัน/ไร่)</th>
                                                <th>อ้อยเข้าหีบ</th>
                                                <th>เทียบประเมิน(%)</th>
                                                <th>ผลงานเกรด</th>
                                            </tr>
                                        </thead>
                                        <tbody class="text-center">
                                            <tr>
                                                <td>อ้อยขยาย</td>
                                                <td>{{ dt.cnt_er | number }}</td>
                                                <td>{{ dt.landvalue_er | number:'1.2-2' }}</td>
                                                <td>{{ dt.target_yield_er | number:'1.2-2' }}</td>
                                                <td>{{ dt.Assess_er | number:'1.2-2' }}</td>

                                                <td>{{ dt.cnt_erf | number }}</td>
                                                <td>{{ dt.landvalue_erf | number:'1.2-2' }}</td>
                                                <td>{{ dt.yields_erf | number:'1.2-2' }}</td>
                                                <td>{{ dt.canein_er | number:'1.2-2' }}</td>
                                                <td>{{ calPercent(dt.Assess_erf, dt.canein_er) | number:'1.2-2' }}
                                                </td>
                                                <td>{{ dt.grad_ern }}</td>
                                            </tr>
                                            <tr>
                                                <td>อ้อยรื้อตอ</td>
                                                <td>{{ dt.cnt_ero | number }}</td>
                                                <td>{{ dt.landvalue_ero | number:'1.2-2' }}</td>
                                                <td>{{ dt.target_yield_ero | number:'1.2-2' }}</td>
                                                <td>{{ dt.Assess_ero | number:'1.2-2' }}</td>

                                                <td>{{ dt.cnt_erof | number }}</td>
                                                <td>{{ dt.landvalue_erof | number:'1.2-2' }}</td>
                                                <td>{{ dt.yields_erof | number:'1.2-2' }}</td>
                                                <td>{{ dt.canein_ero | number:'1.2-2' }}</td>
                                                <td>{{ calPercent(dt.Assess_erof, dt.canein_ero) | number:'1.2-2' }}
                                                </td>
                                                <td>{{ dt.grad_ero }}</td>
                                            </tr>
                                            <tr>
                                                <td>อ้อยตอ</td>
                                                <td>{{ dt.cnt_st | number }}</td>
                                                <td>{{ dt.landvalue_st | number:'1.2-2' }}</td>
                                                <td>{{ dt.target_yield_st | number:'1.2-2' }}</td>
                                                <td>{{ dt.Assess_st | number:'1.2-2' }}</td>

                                                <td>{{ dt.cnt_stf | number }}</td>
                                                <td>{{ dt.landvalue_stf | number:'1.2-2' }}</td>
                                                <td>{{ dt.yields_stf | number:'1.2-2' }}</td>
                                                <td>{{ dt.canein_st | number:'1.2-2' }}</td>
                                                <td>{{ calPercent(dt.Assess_stf, dt.canein_st) | number:'1.2-2' }}
                                                </td>
                                                <td>{{ dt.grad_st }}</td>
                                            </tr>
                                            <tr>
                                                <td>อ้อยต้นฝน</td>
                                                <td>{{ dt.cnt_sr | number }}</td>
                                                <td>{{ dt.landvalue_sr | number:'1.2-2' }}</td>
                                                <td>{{ dt.target_yield_sr | number:'1.2-2' }}</td>
                                                <td>{{ dt.Assess_sr | number:'1.2-2' }}</td>

                                                <td>{{ dt.cnt_srf | number }}</td>
                                                <td>{{ dt.landvalue_srf | number:'1.2-2' }}</td>
                                                <td>{{ dt.yields_srf | number:'1.2-2' }}</td>
                                                <td>{{ dt.canein_sr | number:'1.2-2' }}</td>
                                                <td>{{ calPercent(dt.Assess_srf, dt.canein_sr) | number:'1.2-2' }}
                                                </td>
                                                <td>{{ dt.grad_sr }}</td>
                                            </tr>
                                            <tr class="table-secondary">
                                                <td>รวม</td>
                                                <td>{{ dt.cnt_a | number }}</td>
                                                <td>{{ dt.landvalue | number:'1.2-2' }}</td>
                                                <td>{{ dt.target_yield_al | number:'1.2-2' }}</td>
                                                <td>{{ dt.Assess | number:'1.2-2' }}</td>

                                                <td>{{ dt.cnt_af | number }}</td>
                                                <td>{{ dt.landvalueF | number:'1.2-2' }}</td>
                                                <td>{{ dt.yields_f | number:'1.2-2' }}</td>
                                                <td>{{ dt.canein_f | number:'1.2-2' }}</td>
                                                <td>{{ calPercent(dt.AssessF, dt.canein_f) | number:'1.2-2' }}</td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- 
                            <div class="card-header">
                                <h5 class="mb-0"><b><u>แปลงอ้อย {{yearN.yearDesc_n}}</u></b></h5>
                            </div>
                            <div class="card-body p-0">
                                <div class="report-table-wrapper">
                                    <table class="table table-bordered assess-table">
                                        <thead>
                                            <tr class="text-center">
                                                <th [attr.rowspan]="3">ลำดับ</th>
                                                <th [attr.rowspan]="3">เลขแปลง</th>
                                                <th [attr.rowspan]="3">พื้นที่</th>
                                                <th [attr.rowspan]="3">ประเภทอ้อย</th>
                                                <th [attr.rowspan]="3">เป้าหมายตัน</th>
                                                <th [attr.rowspan]="3">ปริมาณตัน</th>
                                                <th [attr.colspan]="8">โครงการ</th>
                                                <th [attr.rowspan]="3">คนรับผิดชอบ</th>
                                                <th [attr.rowspan]="3">วันปิดแปลง</th>
                                            </tr>
                                            <tr class="table-info text-center">
                                                <th [attr.colspan]="2">น้ำ/อากาศ</th>
                                                <th [attr.colspan]="3">แสงแดด</th>
                                                <th [attr.colspan]="2">ดินมีชีวิต</th>
                                                <th [attr.colspan]="1">ธาตุอาหาร</th>
                                            </tr>
                                            <tr class="text-center">
                                                <th>ระเบิดดาน</th>
                                                <th>พูนโคน</th>
                                                <th>พันธุ์อ้อย</th>
                                                <th>ระยะร่อง</th>
                                                <th>ไม่มีวัชพืช</th>
                                                <th>อินทรีย์</th>
                                                <th>โดโลไมท์</th>
                                                <th>เคมี</th>
                                            </tr>
                                        </thead>
                                        <tbody class="text-center">
                                            <ng-container
                                                *ngIf="getPlantDataByFarmerId(dt.farmer_id).length > 0; else noData">
                                                <tr
                                                    *ngFor="let plant of getPlantDataByFarmerId(dt.farmer_id); let i = index">
                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ plant.intlandno }}</td>
                                                    <td>{{ plant.landvalue_left | number:'1.1-2' }}</td>
                                                    <td>{{ plant.CaneTypeName }}</td>
                                                    <td>{{ plant.target_yield | number }}</td>
                                                    <td>{{ plant.target_cane | number:'1.0-1' }}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #noData>
                                                <tr>
                                                    <td colspan="17" class="text-muted">ไม่มีข้อมูล</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                             -->
                            <div class="card-header">
                                <h5 class="mb-0"><b><u>แปลงอ้อย {{yearN.yearTh}}</u></b></h5>
                            </div>
                            <div class="card-body p-0">
                                <div class="report-table-wrapper">
                                    <table class="table table-bordered table-striped assess-table">
                                        <thead>
                                            <tr class="text-center">
                                                <th [attr.rowspan]="2">ลำดับ</th>
                                                <th [attr.rowspan]="2">เลขแปลง</th>
                                                <th [attr.rowspan]="2">พื้นที่</th>
                                                <th [attr.rowspan]="2">ประเภทอ้อย</th>
                                                <th [attr.rowspan]="2">เป้าหมาย</th>
                                                <th [attr.rowspan]="2">เป้าหมายตัน</th>
                                                <th [attr.rowspan]="2">อ้อยเข้า</th>
                                                <th [attr.rowspan]="2">ตัดพันธุ์จริง</th>
                                                <th [attr.rowspan]="2">ส่วนต่าง</th>
                                                <th [attr.rowspan]="2">%อ้อย</th>
                                                <th [attr.rowspan]="2">ตัน/ไร่</th>
                                                <th [attr.colspan]="7">แปลงเกรดA</th>
                                            </tr>
                                            <tr class="table-info text-center">
                                                <th>ระเบิดดินดาน</th>
                                                <th>อินทรีย์</th>
                                                <th>โดโลไมต์</th>
                                                <th>เคมี1</th>
                                                <th>เคมี2</th>
                                                <th>การงอก</th>
                                                <th>ไม่มีวัชพืช</th>
                                            </tr>
                                        </thead>
                                        <tbody class="text-center">
                                            <ng-container
                                                *ngIf="getPlantDataByFarmerId0(dt.farmer_id).length > 0; else noData">
                                                <tr
                                                    *ngFor="let plant of getPlantDataByFarmerId0(dt.farmer_id); let i = index">
                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ plant.intlandno }}</td>
                                                    <td>{{ plant.landvalue_left | number:'1.1-2' }}</td>
                                                    <td>{{ plant.CaneTypeName }}</td>
                                                    <td>{{ plant.target_yield | number }}</td>
                                                    <td>{{ plant.target_cane | number:'1.0-1' }}</td>
                                                    <td>{{ plant.canein | number:'1.0-1' }}</td>
                                                    <td>{{ plant.cutseedTrue | number:'1.0-1' }}</td>
                                                    <td>{{ plant.succeed_cane | number:'1.0-1' }}</td>
                                                    <td>{{ plant.pc_cane | number:'1.0-1' }}</td>
                                                    <td>{{ plant.yield_cane | number:'1.0-1' }}</td>

                                                    <td> <i
                                                            [ngClass]="plant.is_plowing_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                    <td> <i
                                                            [ngClass]="plant.is_organic_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                    <td> <i
                                                            [ngClass]="plant.is_dolomite_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                    <td> <i
                                                            [ngClass]="plant.is_chemical1_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                    <td> <i
                                                            [ngClass]="plant.is_chemical2_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                    <td> <i
                                                            [ngClass]="plant.is_germ_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                    <td> <i
                                                            [ngClass]="plant.is_weed_pass ? 'far fa-check-square' : 'far fa-square'"></i>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #noData>
                                                <tr>
                                                    <td colspan="18" class="text-muted">ไม่มีข้อมูล</td>
                                                </tr>
                                            </ng-template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="card-body">
                                <!-- ส่วนบันทึกปัญหา / แนวทางแก้ไข / ความต้องการช่วยเหลือ -->
                                <div class="mb-2">
                                    ปัญหา
                                    <div style="border-bottom: 1px dotted gray; padding-bottom: 26px;"></div>
                                    <div style="border-bottom: 1px dotted gray; padding-bottom: 26px;"></div>
                                </div>

                                <div class="mb-2">
                                    แนวทางแก้ไข
                                    <div style="border-bottom: 1px dotted gray; padding-bottom: 26px;"></div>
                                    <div style="border-bottom: 1px dotted gray; padding-bottom: 26px;"></div>
                                </div>

                                <div class="mb-2">
                                    ความต้องการการช่วยเหลือ
                                    <div style="border-bottom: 1px dotted gray; padding-bottom: 26px;"></div>
                                    <div style="border-bottom: 1px dotted gray; padding-bottom: 26px;"></div>
                                </div>

                                <!-- ลายเซ็นชาวไร่ / นอส. -->
                                <table class="w-100" style="margin-top: 30px;">
                                    <tr style="text-align: center;">
                                        <td style="width: 50%; padding-top: 16px;">
                                            ลงชื่อ............................................................ชาวไร่
                                        </td>
                                        <td style="width: 50%; padding-top: 16px;">
                                            ลงชื่อ............................................................นอส.
                                        </td>
                                    </tr>
                                    <tr style="text-align: center;">
                                        <td style="width: 50%; padding-top: 16px;">
                                            (.........{{ dt.fmname }}.........)
                                        </td>
                                        <td style="width: 50%; padding-top: 16px; ">
                                            (............................................................)
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<footer class="footer">
    <app-footer></app-footer>
</footer>